<div class="sort-container">
  <div class="select-title">{{ 'Order_by' | translate }}&nbsp;:&nbsp;</div>
  <mat-select class="sort-select-box"
              [(value)]="selectedSort"
              (selectionChange)="onSortSelectionChange($event.value)"
              [ngStyle]="{'max-width': fullWidth ? 'none' : '200px'}">
    <mat-option class="sort-option" *ngFor="let sort of sortingOptions" [value]="sort">
      <div class="sort-text">{{ 'exercice_'+sort | translate }}</div>
    </mat-option>
  </mat-select>
</div>
